import { Component } from '@angular/core';

@Component({
  selector: 'app-standard-professionali',
  templateUrl: './standard-professionali.component.html',
  styleUrls: ['./standard-professionali.component.scss']
})
export class StandardProfessionaliComponent {

}
